import React from "react";
import "./Banner.css";
import AboutBg from "../assets/Partners-banner.png";

export default function AboutHeader() {
  return (
    <section
      className="aheader-wrapper"
      style={{ backgroundImage: `url(${AboutBg})` }}
    >
      <div className="aheader-overlay">
        <h1 className="aheader-title">Partners</h1>
        <p className="aheader-breadcrumb">
          Home <span className="aheader-separator">›</span> Partners
        </p>
      </div>
    </section>
  );
}
